export default "__VITE_PUBLIC_ASSET__84decb85__"